'use strict';

var StorageService = /** @class */ (function () {
    function StorageService(storePrefix) {
        this.storePrefix = storePrefix;
        this.encoding = false;
        this.defaultPrefix = 'acj_';
        this.storage = null;
    }
    Object.defineProperty(StorageService.prototype, "prefix", {
        // @ts-ignore
        get: function () {
            return this.storePrefix || this.defaultPrefix;
        },
        enumerable: false,
        configurable: true
    });
    StorageService.prototype.formatKey = function (key) {
        return this.prefix + key;
    };
    StorageService.prototype.toOrigKey = function (key) {
        return key.replace(this.prefix, '');
    };
    StorageService.prototype.set = function (key, value) {
        key = this.formatKey(key);
        return this.storage.setItem(key, !value ? value : JSON.stringify(value));
    };
    StorageService.prototype.get = function (key) {
        key = this.formatKey(key);
        var val = this.storage.getItem(key);
        if (val && val !== 'undefined') {
            if (this.encoding) ;
            else {
                val = JSON.parse(val);
            }
        }
        return val;
    };
    StorageService.prototype.getAll = function () {
        var values = {}, keys = Object.keys(this.storage), i = keys.length;
        while (i--) {
            values[keys[i]] = this.get(this.toOrigKey(keys[i]));
        }
        return values;
    };
    StorageService.prototype.delete = function (key) {
        key = this.formatKey(key);
        return this.storage.removeItem(key);
    };
    StorageService.prototype.removeItem = function (key) {
        return this.storage.removeItem(key);
    };
    StorageService.prototype.clear = function () {
        return this.storage.clear();
    };
    return StorageService;
}());

exports.StorageService = StorageService;
